var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 63.462 64.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14420",
    "data-name": "Group 14420",
    transform: "translate(0.089 0.813)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 31.231,
    cy: 31.782,
    rx: 31.231,
    ry: 31.782,
    transform: "translate(0.411 -0.313)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14421",
    "data-name": "Group 14421",
    transform: "translate(45.834 18.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5143",
    "data-name": "Rectangle 5143",
    d: "M0,0H7.726a0,0,0,0,1,0,0V.812A3.312,3.312,0,0,1,4.413,4.124h-1.1A3.312,3.312,0,0,1,0,.812V0A0,0,0,0,1,0,0Z",
    transform: "translate(-18.479 21.901)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5144",
    "data-name": "Rectangle 5144",
    d: "M7.828,0h2.6a7.828,7.828,0,0,1,7.828,7.828V19.9a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.828A7.828,7.828,0,0,1,7.828,0Z",
    transform: "translate(-23.745 1.999)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_471",
    "data-name": "Line 471",
    x2: 24.615,
    transform: "translate(-26.923 21.901)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ba51040970c486e8cb06447f973cc581.svg";
export { ForwardRef as ReactComponent };